import { isRight } from 'fp-ts/lib/Either';
import { ThunkResult } from '../../../redux/configureStore';
import { UserDataGateway } from '../../gateways/userDataGateway.interface';
import * as actionCreators from './actionCreators';
import { OfficeCountry, OfficeLanguage } from '../../config/appConfig';

export const getPopupUseCase =
    (language: OfficeLanguage, country: OfficeCountry): ThunkResult<void> =>
    async (dispatch, getState, { userDataGateway }: { userDataGateway: UserDataGateway }) => {
        dispatch(actionCreators.Actions.popupFetching());

        const result = await userDataGateway.getPopup(language, country);

        if (isRight(result)) {
            dispatch(actionCreators.Actions.popupRetrieved(result.right));
        } else {
            dispatch(actionCreators.Actions.popupFailed());
        }
    };
